/**
 * @generated SignedSource<<5dba3a144ab42cf95f6adf8ddd214d30>>
 * @relayHash d1f433c5859a639556bc75700750a999
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 120a251ef0e72af4b4ef1b63e426a00a7b1a22b16ee4caccb4dd87acdfa9d006

import type { ConcreteRequest } from 'relay-runtime';
export type PageCardInPageTreeHoverPreference = "NO_OPTION_SELECTED" | "NO_SHOW_PAGECARD" | "SHOW_PAGECARD" | "%future added value";
export type useHoverPageCardsOptStatusHoverPageCardsOptStatusQuery$variables = Record<PropertyKey, never>;
export type useHoverPageCardsOptStatusHoverPageCardsOptStatusQuery$data = {
  readonly userPreferences: {
    readonly shouldShowCardOnPageTreeHover: PageCardInPageTreeHoverPreference;
  } | null | undefined;
};
export type useHoverPageCardsOptStatusHoverPageCardsOptStatusQuery = {
  response: useHoverPageCardsOptStatusHoverPageCardsOptStatusQuery$data;
  variables: useHoverPageCardsOptStatusHoverPageCardsOptStatusQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "concreteType": "UserPreferences",
    "kind": "LinkedField",
    "name": "userPreferences",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "shouldShowCardOnPageTreeHover"
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "useHoverPageCardsOptStatusHoverPageCardsOptStatusQuery",
    "selections": (v0/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "useHoverPageCardsOptStatusHoverPageCardsOptStatusQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "d1f433c5859a639556bc75700750a999",
    "id": "120a251ef0e72af4b4ef1b63e426a00a7b1a22b16ee4caccb4dd87acdfa9d006",
    "metadata": {},
    "name": "useHoverPageCardsOptStatusHoverPageCardsOptStatusQuery",
    "operationKind": "query",
    "text": "query useHoverPageCardsOptStatusHoverPageCardsOptStatusQuery{userPreferences{shouldShowCardOnPageTreeHover}}"
  }
};
})();

(node as any).hash = "1e92ca51a019c1c7e4b73556b6c593ea";

export default node;
